import { PageHeader } from '@ant-design/pro-layout';
import { Grid } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { FC, useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { BackButton } from '../../../../../../shared/back-button';
import { HorizonalTabs, RouteDefinition } from '../../../../../../shared/horizontal-tabs';
import { ApplicationCredCase } from './pages/application';
import { MessagesCredCase } from './pages/messages';
import { TransactionsCredCase } from './pages/transactions';

interface CredentialVerificationV1CaseDetailsProps {}
export const CredentialVerificationV1: FC<CredentialVerificationV1CaseDetailsProps> = (_props) => {
  const navigate = useNavigate();

  // redirect to (default) Chat if a case is selected
  const rootRoutePath = useResolvedPath('');
  const match = useMatch(rootRoutePath.pathname);
  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;
  useEffect(() => {
    if (match) {
      navigate('');
    }
  }, [match]);

  const pages = [
    {
      id: '1',
      path: ``,
      title: 'Messages',
      icon: undefined
    },
    {
      id: '2',
      path: 'application',
      title: 'Application',
      icon: undefined
    },
    {
      id: '3',
      path: 'transactions',
      title: 'Transactions',
      icon: undefined
    },
  ];

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  const routes: RouteDefinition[] = [
    { id: '1', path: ``, element: <MessagesCredCase /> },
    { id: '2', path: 'application/*', element: <ApplicationCredCase /> },
    { id: '3', path: 'transactions/*', element: <TransactionsCredCase /> },
  ];

  return (
    <div style={{ width: '100%' }}>
      <Header style={{ position: 'fixed', padding: '0px', width: '100%', background: 'white', zIndex: '1000', marginTop: isMobile ? '35px' : '0px'}}>
        <PageHeader title="Credential Verification Case" />
      </Header>
      {isMobile && <BackButton onBack={() => navigate('/applicant/cases')} title="Back to Cases" />}
      <HorizonalTabs routes={routes} menuItems={configPageNavigationMenu} />
    </div>
  );
};
